//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FixedManage',
  components: {
    fixed: function fixed() {
      return import('./components/fixed');
    }
  }
};